import emailjs from '@emailjs/browser';
import React, { useRef } from 'react'
import { MdOutgoingMail } from "react-icons/md";
import {SiWhatsapp } from "react-icons/si";
import { FaLinkedinIn,FaFacebookF,FaInstagram } from "react-icons/fa";
function Contact() {

    const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_f7wwfmh', 'template_4mxogn2', form.current, 'Q8aJzaFW5M-WHRSRW')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };

  const phone = {
    href: "tel:+8801789368876",
    target: "_blank",
  };
  const mail = {
    href: "mailto: tasmia1070@gmail.com",
    target: "_blank",
  };

  const facebook = {
    href: "https://www.facebook.com/fahmidaTasmia76/",
    target: "_blank",
  };
  const linkedin = {
    href: "https://www.linkedin.com/in/fahmida-tasmia/",
    target: "_blank",
  };
  const instagram = {
    href: "https://www.instagram.com/___sunshine_76/",
    target: "_blank",
  };
  return (
    <div className='min-h-screen max-w-screen-xl mx-auto '>
       <h2 className="font-bold text-6xl  md:text-[120px] text-gray-300 opacity-[0.3] text-center animate-pulse numb">CONTACT</h2>
       <div className="text-center absolute md:top-[3%] lg:top-[8%] top-[2%] md:left-[37%] lg:left-[46%] left-[28%]">
       <h2 data-aos="fade-up" className=" font-bold text-xl md:text-4xl text-neutral">CONTACT ME</h2>
       </div>
      <div className='grid md:grid-cols-2'>
        {/* start rightdiv */}
      <div className="m-auto lg:border-r-2 lg:border-dashed  ">
      <div className='grid gap-5  scale-90'>
      <div data-aos="zoom-in-right"  style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className="duration-150 card cursor-pointer w-96  bg-transparent border border-sky-200 hover:border-2 hover:border-neutral rounded-md shadow-sm  text-neutral-content">
          <div className="card-body items-center   md:text-normal text-sm">
            <h2 className="text-center font-bold text-xl"><MdOutgoingMail className='text-4xl  text-neutral'></MdOutgoingMail></h2>
             <div className=' '>
             <a {...mail} className=" text-lg">
               
                  <span className="hover:text-neutral duration-150  hover:border-b-2 hover:border-neutral  font-bold">
                  
                    tasmia1070@gmail.com
                  </span>
                </a>
             </div>
            </div>
          </div>
          {/* phonme */}
          <div data-aos="zoom-in-left"  style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} className="duration-150 card cursor-pointer w-96  bg-transparent border border-sky-200 hover:border-2 hover:border-neutral rounded-md shadow-sm  text-neutral-content">
          <div className="card-body items-center   md:text-normal text-sm">
            <h2 className="text-center font-bold text-xl"><SiWhatsapp className='text-4xl  text-neutral'></SiWhatsapp></h2>
             <div className='mt-2 '>
             <a {...phone} className=" text-lg">
               
                  <span className="hover:text-neutral duration-150  hover:border-b-2 hover:border-neutral  font-bold">
                  01789368876
                  </span>
                </a>
             </div>
            </div>
          </div>
          {/* facebookmy */}
          <div data-aos="zoom-in-up" style={{ boxShadow: "inset -2px 0px 6px #70acc7" }}  className='flex gap-3  justify-center border rounded-full p-2 shadow-lg'>
          <a {...facebook} className=" text-lg">
               
            <span className='btn btn-circle border-2 bg-transparent hover:bg-transparent hover:shadow-md shadow-lg'><FaFacebookF className='text-2xl '></FaFacebookF></span>
             </a>
             <a {...linkedin} className=" text-lg">
               
               <span  className='btn btn-circle border-2 bg-transparent hover:bg-transparent hover:shadow-md shadow-lg'><FaLinkedinIn className='text-2xl'></FaLinkedinIn></span>
                </a>
                <a {...instagram} className=" text-lg">
               
               <span  className='btn btn-circle border-2 bg-transparent hover:bg-transparent hover:shadow-md shadow-lg'><FaInstagram className='text-2xl'></FaInstagram></span>
                </a>
          </div>
      </div>
               
                
              </div>
              {/* end rightdiv */}
      <div className='border border-dashed '>
     
    <div className='scale-90'>
    <form ref={form} onSubmit={sendEmail}   data-aos="zoom-in-right" >
                        
                        <div className='grid  gap-4'>
                            <input name="firstName" type="text" placeholder="Your Full Name" 
                            className="input  bg-transparent border border-neutral rounded-sm "  style={{ boxShadow: "inset -2px 0px 6px #70acc7" }}/>
                                    
                            <input name="email" type="text" placeholder="Your Email"   
                            className="input  bg-transparent border border-neutral rounded-sm "  style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} />

                            <input name="subject" type="text" placeholder="Subject"  
                            className="input  bg-transparent border border-neutral rounded-sm "  style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} />
                            </div>
                            <textarea name="message" className="textarea bg-transparent border border-neutral rounded-sm  h-40 w-full my-5 "  style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} 
                            placeholder="Your Message" required></textarea>
        
                            <input className='btn bg-transparent border border-neutral rounded-md hover:text-white hover:bg-neutral' style={{ boxShadow: "inset -2px 0px 6px #70acc7" }} type="submit" value="Send Message" />
                    </form>
    </div>

                    
      </div>
    </div>
    <div className='py-10 lg:visible invisible'></div>
    </div>
  )
}

export default Contact
